/**
 * Feature toggle to enable deep linking to blog categories on the top nav bar for logged out users
 */
export const ENABLE_BLOG_DEEP_LINK_CATEGORIES_240605 = 'ENABLE_BLOG_DEEP_LINK_CATEGORIES_240605';
